import React from 'react'
import { FormControlLabel, IconButton, makeStyles, Typography } from '@material-ui/core'
import { AccordionSummaryViewType, MyAccordionCtrlType } from './accordionType'
import useAccordion from './useAccordion'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import SearchIcon from '@material-ui/icons/Search'
import SearchRoundedIcon from '@material-ui/icons/SearchRounded'
import { ArrowBackRounded } from '@material-ui/icons'
const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        marginBottom: 1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        backgroundColor: '#fafafa',
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},

    expandIcon: {
        '&$expanded': {
            transform: 'rotate(360deg)',
        },
        transform: 'rotate(360deg)',
    },
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        border: '1px solid rgba(0, 0, 0, .125)',
        borderRadius: '8px',
    },
}))(MuiAccordionDetails)

const SearchAccordionView: React.FC<AccordionSummaryViewType> = ({
    title,
    children,
    isBack,
    onClickBack,
    onChange,
    defaultExpanded,
}) => {
    const classes = useStyles()

    let iconControl = isBack ? (
        <IconButton aria-label="search" color="inherit" className={classes.icon} size="small" onClick={onClickBack}>
            <ArrowBackRounded color="inherit" />
        </IconButton>
    ) : (
        <></>
    )

    return (
        <Accordion
            square
            onChange={(event, expanded) => {
                onChange?.(expanded)
            }}
            defaultExpanded={defaultExpanded ?? true}
        >
            <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={
                    <IconButton className={classes.searchIcon}>
                        <SearchRoundedIcon color={'inherit'} />
                    </IconButton>
                }
            >
                <>
                    <FormControlLabel
                        aria-label="Acknowledge"
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        control={iconControl}
                        label={''}
                    />
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginLeft: '-22px' }}>
                        {title}
                    </Typography>
                </>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    )
}

let SearchAccordion: React.FC<MyAccordionCtrlType> = ({ ...others }) => {
    const myAutocomplete = useAccordion(others)
    return <SearchAccordionView {...myAutocomplete} {...others} />
}

export default SearchAccordion
const useStyles = makeStyles((theme) => ({
    icon: {
        border: '1px solid rgba(0, 0, 0, .125)',
        '&:hover': {
            backgroundColor: '#DB5F8E',
        },
        marginRight: '12px',
    },
    searchIcon: {
        width: '40px',
        height: '40px',

        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
}))
